export default "__VITE_ASSET__CzaZwZty__"